import { render, staticRenderFns } from "./SubmitTicket.vue?vue&type=template&id=244dc338&scoped=true"
import script from "./SubmitTicket.vue?vue&type=script&lang=js"
export * from "./SubmitTicket.vue?vue&type=script&lang=js"
import style0 from "./SubmitTicket.vue?vue&type=style&index=0&id=244dc338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244dc338",
  null
  
)

export default component.exports